import env from './.env';
import { API_ENDPOINT, HeaderKey } from '../config/api-endpoints';
import { updateHeaders } from '../config/update-headers';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export interface Environment {
  metrics?: boolean;
  theme: string;
  authServerUrl?: string;
  production: boolean;
  hmr: boolean;
  MSW: boolean;
  notifyError: boolean;
  appName: string;
  defaultLanguage: string;
  nestServerUrl: string;
  serverUrl: string;
  tier: string;
  defaultClientId: string;
  version: string;
  commit: string;
  branch: string;
  copyRight: string;
  storageUrl: string;
  defaultCountry: string;
  supportedLanguages: string[];
  dateFormat: string;
  dateThaiFormat: string;
  monthFormat: string;
  timeFormat: string;
  dateTimeFormat: string;
  dateTimeNanoSec: string;
  dateTimeDisplay: string;
  date_time: string;
  dateISO8601: string;
  imgUrl: string;
  assetPath: string;
  iconPath: string;
  usb: { vendorId: number; productId: number };
  relayPrinterUrl: string;
  regexp: { imageType: string };
  cookies: {
    maxSizePerCookies: number;
    bufferTimePeriod: number;
    domain: string;
    path: string;
    accessToken: string;
    refreshToken: string;
  };
  services?: typeof API_ENDPOINT; // เพิ่มตรงนี้
  appTitle: string;
  unleashUrl: string;
  unleashClientKey: string;
  unleashAppName: string;
  unleashEnvironment: string;
  unleashCustomHeaders: Record<string, string>;
  unleashRefreshInterval: number;
}

let environment: Environment = {
  appTitle: 'POS Manager',
  production: false,
  hmr: false,
  MSW: false,
  notifyError: false,
  theme: 'yellow',
  appName: env.AppName,
  defaultLanguage: 'en-US',
  nestServerUrl: 'https://api-dev.cjxstore.com',
  serverUrl: 'https://edge-dev.cjxstore.com',
  tier: 'develop',
  defaultClientId: 'CJX_POS_MANAGER_APPL',
  version: env.version + '-localhost',
  commit: env.commit,
  branch: env.branch,
  copyRight: 'CJ MART Co.,Ltd. All rightS reserved. posmgr-cjx.tdtech.app',
  storageUrl: 'https://storage.googleapis.com',
  defaultCountry: 'Thailand',
  supportedLanguages: ['en-US', 'th'],
  dateFormat: 'DD/MM/YYYY',
  dateThaiFormat: 'DD MM YYYY',
  monthFormat: 'MM/YYYY',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'YYYY-MM-DDTHH:mm:ss',
  dateTimeNanoSec: 'YYYY-MM-DDTHH:mm:ss.SSS',
  dateTimeDisplay: 'DD/MM/YYYY HH:mm',
  date_time: 'DDMMYYYY_HHmm',
  dateISO8601: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
  imgUrl: 'https://storage.googleapis.com/product-assortments-dev',
  assetPath: '/assets/images',
  iconPath: '/assets/layout/images/icons',
  usb: {
    vendorId: 1003,
    productId: 38456
  },
  // Relay เป็น service ที่ติดตั้งบนเครื่องพีซีหน้าร้าน คุยกับ mobile printer ผ่าน TCP 9100 แทนเบราว์เซอร์
  // port 17777 มาจาก API Spec ของ BE — เครื่องพิมพ์ที่จะใช้ตั้งใน relay.properties ฝั่ง relay ไม่ใช่ที่นี่
  relayPrinterUrl: 'http://localhost:17777',
  regexp: {
    imageType: '.*.(gif|jpe?g|bmp|png)$'
  },
  cookies: {
    maxSizePerCookies: 3500,
    bufferTimePeriod: 1800000,
    domain: 'localhost',
    path: '/',
    accessToken: 'bo-access-token',
    refreshToken: 'bo-refresh-token'
  },
  unleashUrl: 'https://unleash.nonprod-platform.tdtech.app/api/frontend/',
  unleashClientKey: 'cjx:development.17de3b3a616d7327c7dba95f8c38d2ce7f067cfcd7ffd08c648f318b',
  unleashAppName: 'cjx-pos-manager',
  unleashEnvironment: 'development',
  unleashCustomHeaders: { 'UNLEASH-SDK': 'unleash-posmanager-sdk:3.10.0' },
  unleashRefreshInterval: 120
};

export const X_HOST_HEADER = {
  [HeaderKey.Authorization]: {
    // Authorization: 'Basic QURNSU5fUE9SVEFMOlBAc3N3MHJk', // For NEST APP
    Authorization: 'Basic Q0pYX1BPU19NQU5BR0VSX0FQUEw6UEBzc3cwcmQ=',
    // Authorization: 'Basic UE9TX0FQUEw6UEBzc3cwcmQ=', // For POS MANAGER APP
    // 'x-host': 'oauth.api.tdshop.io'
    'x-host': 'oauth.api.cjxstore.com'
  },
  [HeaderKey.PosApiWithTenant]: {
    'x-host': 'pos.api.cjxstore.com',
    'x-tenant-id': '*:*:*:*'
  },
  [HeaderKey.IdentityApi]: {
    'x-host': 'identity.api.cjxstore.com'
  }
};

environment.services = updateHeaders(API_ENDPOINT, X_HOST_HEADER);

export { environment };
